import { z } from 'zod'

export const authForgetPasswordSchema = z.object({
  email: z
    .string()
    .min(1, 'Por favor, informe um e-mail')
    .email('Informe um e-mail válido'),
})

export type AuthForgetPasswordSchema = z.infer<typeof authForgetPasswordSchema>